import { SxProps, Theme } from '@mui/material';
import { UserStatus } from 'src/@types/user-status';
import { MASK_LARGE, MASK_MEDIUM, MASK_SMALL, MASK_XSMALL } from './constants';

export type CPAvatarSize =
  | 'small'
  | 'medium'
  | 'large'
  | 'xSmall'
  | 'xLarge'
  | 'uSmall';

export type CPAvatarProps = {
  name: string;
  status?: UserStatus | null;
  picture?: string | null;
  size?: CPAvatarSize;
  mask?: boolean;
};

export const avatarSizes: Record<
  CPAvatarSize,
  SxProps<Theme> & { clipPath: string }
> = {
  uSmall: {
    width: 20,
    height: 20,
    fontSize: '0.5rem',
    clipPath: `path("${MASK_XSMALL}")`,
  },
  xSmall: {
    width: 24,
    height: 24,
    fontSize: '0.75rem',
    clipPath: `path("${MASK_XSMALL}")`,
  },
  small: {
    width: 32,
    height: 32,
    clipPath: `path("${MASK_SMALL}")`,
  },
  medium: {
    width: 40,
    height: 40,
    clipPath: `path("${MASK_MEDIUM}")`,
  },
  large: {
    width: 48,
    height: 48,
    clipPath: `path("${MASK_LARGE}")`,
  },
  xLarge: {
    width: 92,
    height: 92,
    clipPath: `path("${MASK_LARGE}")`,
    fontSize: '3em !important',
  },
};

export const avatarSizeBorder = {
  uSmall: 1,
  xSmall: 1.5,
  small: 2,
  medium: 2.5,
  large: 3,
  xLarge: 5,
};
